import { usePhoneExtsManager } from "./use-phone-exts";

function PhoneExtsManager () {
  usePhoneExtsManager();

  return null;
}

export default PhoneExtsManager;
